import React, { useContext } from "react";
import MainLayout from "../../layouts/MainLayout/MainLayout";
import "./Dashboard.css";
import ActiveCourseCard from "../../features/Dashboard/CourseCard/ActiveCourseCard";
import DailyRecommendationCard from "../../features/Dashboard/DailyRecommendationCard/DailyRecommendationCard";
import AppContext from "../../contexts/AppContext";
import ReminderAndSponsors from "../../features/Dashboard/ReminderAndSponsors/ReminderAndSponsors";
import Surveys from "../../features/Surveys/Surveys";
import Tour from "../../features/Dashboard/DashboardComponents/Tour";
import Calendar from "../../features/Dashboard/DashboardComponents/Calendar";


function Dashboard() {
   const { currentUser, isCalendarCollapsed, remainingSurvey } = useContext(AppContext);

   return (
      <>
         <Tour />
         <MainLayout>
            <div
               className={`${isCalendarCollapsed
                  ? "dashboard__layout--collapsed"
                  : "dashboard__layout"
                  }`}
            >
                <div className="dashboard__header">
                    <p className="dashboard__header__userName">¡Hola, {currentUser.name}!</p>
                </div>
                <Calendar />
                <div className="dashboard__main">
                    <ActiveCourseCard/>
                    <ReminderAndSponsors/>
                    <Surveys remainingSurvey={remainingSurvey}/>
                    <DailyRecommendationCard/>
                    
                </div>

            </div>
         </MainLayout>
      </>
   );
}

export default Dashboard;
